module.exports = __webpack_public_path__ + "static/media/google-play-badge.cfea2442.svg";